import VueScrollTo from 'vue-scrollto'
import commonsApi from '@/api/commons'
export default {
  data () {
    return {
      loading: false,
      isOnEditMode: false
    }
  },
  props: {
    id: {
      type: [String, Number],
      default: 'form'
    }
  },
  methods: {
    showToastFormError (msg = this.$t('form_with_errors')) {
      this.$bvToast.toast(msg, {
        title: 'Error',
        toaster: 'b-toaster-bottom-center',
        variant: 'danger',
        solid: true
      })
    },
    errorScrollTo () {
      VueScrollTo.scrollTo(this.id, 1000, { offset: -60 })
    },
    validationForm (validation, mustShowToat = true) {
      validation.$touch()
      if (validation.$error) {
        if (mustShowToat) {
          this.showToastFormError()
        }
        this.errorScrollTo()
        return Promise.reject(new Error('validation error'))
      } else {
        if (!validation.$pending || !validation.$error) {
          return Promise.resolve(true)
        } else {
          Promise.reject(new Error('validation error'))
        }
      }
    },
    hideLoading () {
      this.loading = false
    },
    showLoading () {
      this.loading = true
    },
    async activeEditMode (getItemDetailObj, form = 'form') {
      try {
        this.isOnEditMode = true
        this.$emit('onEditMode', true)
        this.showLoading()
        const response = await commonsApi.getItemDetail({
          path: getItemDetailObj.path,
          id: getItemDetailObj.id,
          paramsMode: getItemDetailObj.paramsMode
        })
        this.$parent[form] = response
        if ('softPermissions' in response) {
          this.$parent['softPermissions'] = response.softPermissions
        }
        this.hideLoading()
      } catch (error) {
        this.hideLoading()
        console.log('error: ', error)
        throw error
      }
    }
  }
}
